const NICE_STEP_MULTIPLIERS = [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10];

const getNiceStepCeil = (rawStep: number) => {
  if (rawStep <= 0) {
    return 1;
  }

  const magnitude = Math.pow(10, Math.floor(Math.log10(rawStep)));
  const normalized = rawStep / magnitude;
  const niceMultiplier =
    NICE_STEP_MULTIPLIERS.find((multiplier) => multiplier >= normalized) ?? 10;

  return niceMultiplier * magnitude;
};

export default getNiceStepCeil;
